export default __webpack_public_path__ + "static/media/icon-localizacao.4de134b1.svg";